import { CurrentView, FloorViewMode, SpaceFloorViewMode, ProjectFocusMode } from './-constants'
import { BuildingState } from './-types'

export default (): BuildingState => ({
  currentView: CurrentView.BUILDING,
  canvasElement: null,
  cdnBase: '',
  buildingCode: '',
  project: {},
  activeProject: '',
  client: '',
  space: {},
  isInitialized: false,
  floorViewMode: FloorViewMode.DEFAULT,
  projectFocusMode: ProjectFocusMode.DEFAULT,
  spaceFloorViewMode: SpaceFloorViewMode.ALL,
  fitoutData: {
    initialized: false,
    data: []
  },
  loadingScreenActive: true,
  finishedLoadingAssets: false,
  settings: {},
  assetLoadingError: null,
  defaultFilterPinsMode: '',
  webGLContextLost: false,
  activeFocusPointPin: null
})
